import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type IndicatorParamWithId = {
  idIndicatorParam: number;
};

// Базовый тип для create/update операций параметров индикаторов
type IndicatorParamCreateUpdateData = IndicatorParamWithId & {
  idIndicator: number;
  name: string;
  type: string;
  index: number;
  defaultValue: unknown;
};

// Типы для WebSocket сообщений компонента indicatorParams
type IndicatorParamsListMessage = WebSocketMessageWithFields<'indicator-set-list' | 'indicator-param-list' | 'pair', {
  indicatorParams: unknown[];
}>;
type IndicatorParamListNotFoundMessage = WebSocketMessageEmpty<'indicator-param-list-not-found'>;
type IndicatorParamCreateMessage = WebSocketMessageWithFields<'indicator-param-create' | 'indicator-param-create-success', IndicatorParamCreateUpdateData>;
type IndicatorParamUpdateMessage = WebSocketMessageWithFields<'indicator-param-update' | 'indicator-param-update-success', IndicatorParamCreateUpdateData>;
type IndicatorParamDeleteMessage = WebSocketMessageWithFields<'indicator-param-delete' | 'indicator-param-delete-success', IndicatorParamWithId>;

// Объединенный тип для всех сообщений
type IndicatorParamsWebSocketMessage = 
  | IndicatorParamsListMessage 
  | IndicatorParamListNotFoundMessage 
  | IndicatorParamCreateMessage 
  | IndicatorParamUpdateMessage 
  | IndicatorParamDeleteMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataIndicatorParams',
},
  __name: 'indicatorParams',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID параметра индикатора
const handleWebSocketMessage = (data: IndicatorParamsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'indicator-set-list':
    case 'indicator-param-list':
    case 'pair':
      store.dispatch('indicatorParams/wsSetIndicatorParams', {indicatorParams: data.indicatorParams});
      break;
    case 'indicator-param-list-not-found':
      store.dispatch('indicator/wsSetEmptyIndicator');
      break;
    case 'indicator-param-create':
    case 'indicator-param-create-success':
      store.dispatch('indicatorParams/wsIndicatorParamCreate', {
        idIndicatorParam: data.idIndicatorParam,
        idIndicator: data.idIndicator,
        name: data.name,
        type: data.type,
        index: data.index,
        defaultValue: data.defaultValue,
      });
      break;
    case 'indicator-param-update':
    case 'indicator-param-update-success':
      store.dispatch('indicatorParams/wsIndicatorParamUpdate', {
        idIndicatorParam: data.idIndicatorParam,
        idIndicator: data.idIndicator,
        name: data.name,
        type: data.type,
        index: data.index,
        defaultValue: data.defaultValue,
      });
      break;
    case 'indicator-param-delete':
    case 'indicator-param-delete-success':
      store.dispatch('indicatorParams/wsIndicatorParamDelete', {
        idIndicatorParam: data.idIndicatorParam,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})